export { default } from './forEachRight.js'



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/eachRight.js
// module id = 601
// module chunks = 41